import { FilterType } from "../../components/menuComposer/_types";
import { SieveOperatorEnumToStringMapping } from "./sieveConstants";

export const serializeFilter = (filters: FilterType[]) => {
    return filters.map(filter => {
        const operatorAsString = SieveOperatorEnumToStringMapping[filter.operator];
        return `${encodeURIComponent(filter.name)}${operatorAsString}${filter.value}`
    }).join(',');
};
